/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pre-op-sign-in.reducer';

export const PreOpSignIn = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const preOpSignInList = useAppSelector(state => state.preOpSignIn.entities);
  const loading = useAppSelector(state => state.preOpSignIn.loading);
  const totalItems = useAppSelector(state => state.preOpSignIn.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pre-op-sign-in-heading" data-cy="PreOpSignInHeading">
        <Translate contentKey="tinyMedicRestApp.preOpSignIn.home.title">Pre Op Sign Ins</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.preOpSignIn.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/pre-op-sign-in/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.preOpSignIn.home.createLabel">Create new Pre Op Sign In</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.preOpSignIn.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {preOpSignInList && preOpSignInList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('patientConfirmation')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.patientConfirmation">Patient Confirmation</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientConfirmation')} />
                </th>
                <th className="hand" onClick={sort('identity')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.identity">Identity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('identity')} />
                </th>
                <th className="hand" onClick={sort('siteAndSide')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.siteAndSide">Site And Side</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('siteAndSide')} />
                </th>
                <th className="hand" onClick={sort('procedure')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.procedure">Procedure</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('procedure')} />
                </th>
                <th className="hand" onClick={sort('consent')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.consent">Consent</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('consent')} />
                </th>
                <th className="hand" onClick={sort('siteMarked')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.siteMarked">Site Marked</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('siteMarked')} />
                </th>
                <th className="hand" onClick={sort('anaesthesiaCheck')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.anaesthesiaCheck">Anaesthesia Check</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('anaesthesiaCheck')} />
                </th>
                <th className="hand" onClick={sort('knownAllergies')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.knownAllergies">Known Allergies</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('knownAllergies')} />
                </th>
                <th className="hand" onClick={sort('airwayRisk')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.airwayRisk">Airway Risk</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('airwayRisk')} />
                </th>
                <th className="hand" onClick={sort('bloodLoss')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.bloodLoss">Blood Loss</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodLoss')} />
                </th>
                <th className="hand" onClick={sort('bloodReserved')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.bloodReserved">Blood Reserved</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('bloodReserved')} />
                </th>
                <th className="hand" onClick={sort('documentsReady')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.documentsReady">Documents Ready</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('documentsReady')} />
                </th>
                <th className="hand" onClick={sort('equipmentReady')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.equipmentReady">Equipment Ready</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('equipmentReady')} />
                </th>
                <th className="hand" onClick={sort('implantReady')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.implantReady">Implant Ready</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('implantReady')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.anaesthesiologist">Anaesthesiologist</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.preOpSignIn.nurse">Nurse</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {preOpSignInList.map((preOpSignIn, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pre-op-sign-in/${preOpSignIn.id}`} color="link" size="sm">
                      {preOpSignIn.id}
                    </Button>
                  </td>
                  <td>{preOpSignIn.patientConfirmation ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.identity ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.siteAndSide ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.procedure ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.consent ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.siteMarked ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.anaesthesiaCheck ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.knownAllergies ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.airwayRisk ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.bloodLoss ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.bloodReserved ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.documentsReady ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.equipmentReady ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.implantReady ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.active ? 'true' : 'false'}</td>
                  <td>{preOpSignIn.cursor}</td>
                  <td>{preOpSignIn.lastupdated}</td>
                  <td>{preOpSignIn.microSec}</td>
                  <td>{preOpSignIn.timestampentry}</td>
                  <td>
                    {preOpSignIn.surgery ? <Link to={`/patient-procedure/${preOpSignIn.surgery.id}`}>{preOpSignIn.surgery.id}</Link> : ''}
                  </td>
                  <td>
                    {preOpSignIn.anaesthesiologist ? (
                      <Link to={`/doctor/${preOpSignIn.anaesthesiologist.id}`}>{preOpSignIn.anaesthesiologist.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>{preOpSignIn.nurse ? <Link to={`/nurse/${preOpSignIn.nurse.id}`}>{preOpSignIn.nurse.id}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/pre-op-sign-in/${preOpSignIn.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pre-op-sign-in/${preOpSignIn.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pre-op-sign-in/${preOpSignIn.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.preOpSignIn.home.notFound">No Pre Op Sign Ins found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={preOpSignInList && preOpSignInList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PreOpSignIn;
